import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { ArticleVersion } from '../article-version';
import { ArticleBuilder } from './article.builder';
import { OperationProcessBuilder } from './operation-process.builder';

export class ArticleVersionBuilder {
  static fromJson(json) {
    return (json)
      ? new ArticleVersion(
        json.hash,
        json.article ? ArticleBuilder.fromJson(json.article) : null,
        json.lastVersion,
        json.operations ? OperationProcessBuilder.fromList(json.operations) : null
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByString('hash', mapCollection(ArticleVersionBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/article-version.builder.ts